/**
 * Enum representing different durations of time.
 *
 * This enum is typically used for specifying time-based intervals in features
 * such as filtering, scheduling, or data grouping (e.g., "last hour", "per week", etc.).
 */
export enum Duration {
  /**
   * Represents a one-minute duration
   */
  MINUTE = "minute",
  /**
   * Represents a one-hour duration
   */
  HOUR = "hour",

  /**
   * Represents a one-day duration
   */
  DAY = "day",

  /**
   * Represents a one-week duration
   */
  WEEK = "week",

  /**
   * Represents a one-month duration
   */
  MONTH = "month",
}
